module.exports = __webpack_public_path__ + "media/images/return_cases/security-847426d93268052434d7797a12a0c69e.svg";